
import {defineComponent, nextTick} from 'vue'
import alertBox from '@/components/alert-box.vue'
import { dateFormat, confirm, downLoadFile } from '@/utils/util'
import {
  approval, getApprovalProcess
} from '@/api/pay.ts'

export default defineComponent({
  components: {
    alertBox
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    approvalId: {
      type: [Number, String],
      default: ''
    },
    userId: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      isApprovalPopup: false,
      approvalInfo: {} as any,
      flowNodeList: [],
      approvalForm: {
          isAgree: 1, // 0取消 1同意 2驳回
          auditContent: ''
      },
        flowStateEnum: {
            progress: 0,
            access: 1,
            refuse: 2,
            cancel: 3
        },
        isAgreeOptions: [
            {
                label: '同意',
                value: 1
            },
            {
                label: '驳回',
                value: 2
            },
        ],
        presetConfirmRemark: ['同意', '确认', 'OK', '情况属实', '已审核', '已核实'],
        presetRefuseRemark: ['不同意', '拒绝', '取消', '作废', '重复提交', '请核实', '金额不对'],
        waitForMe: false,
        applyForMe: false,
    }
  },
  watch: {
    show(newval) {
      this.isApprovalPopup = newval
      if (newval) {
        this.getApprovalProcess()
      }
    },
    isApprovalPopup(newval) {
      this.$emit('update:show', newval)
    }
  },
  methods: {
    // 获取审批流列表
    async getApprovalProcess() {
      this.loading = true
      let waitForMe = false
      const examine = await getApprovalProcess({
          processId: Number(this.approvalId)
      })

        if (examine.approvalProcess[examine.flow - 1]?.approvalInformations.find(item => item.approverId === this.userId)) {
            waitForMe = true
        }
      examine.approvalProcess?.forEach(item => {
        // 多人审批时，查找审批人
        const approver = item.approvalInformations.find(i => i.state)
        item.state = approver?.state
        item.createTime = approver?.createTime
        item.auditContent = approver?.auditContent || ''
      })
      this.waitForMe = waitForMe
      this.applyForMe = examine.createUserId === this.userId
      this.approvalInfo = examine
        const nodeList = [
        {
            nodeName: examine.createUserName,
            nodeIconUrl: examine.createUserHeadUrl,
            createTime: examine.createTime,
            state: 1,
            stateName: '发起申请',
            approvalInformations: [
                {
                    userHeadUrl: examine.createUserHeadUrl,
                    userName: examine.createUserName
                }
            ]
        },
        ...examine.approvalProcess
      ]
        if (examine.copyUser?.length) {
            nodeList.push({
                nodeName: '抄送',
                nodeIconUrl: '/packagePay/assets/img/flow/copy-green.png',
                state: 1,
                stateName: '抄送',
                createTime: examine.copyUser?.[0]?.createTime,
                approvalInformations: examine.copyUser || []
            })
        }

        this.flowNodeList = nodeList

      this.loading = false
      nextTick(() => {
        const nodeList = document.querySelectorAll('.approval .flow-node')
        nodeList[examine.flow]?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        })
      })
    },
      translateState(state: number, idx: number) {
        if (this.approvalInfo.flow === idx && state === this.flowStateEnum.progress) {
            return '审批中'
        }
        switch (state) {
          case 1:
            return '审批通过'
          case 2:
            return '审批驳回'
          default:
            return '待审批'
        }
      },

      translateStateColor(state: number, idx: number) {
          if (this.approvalInfo.flow === idx && state === this.flowStateEnum.progress) {
              return '#1989FA'
          }
          switch (state) {
              case 1:
                  return '#00D679'
              case 2:
                  return '#FF7642'
              default:
                  return '#202536'
          }
      },
    // 关闭审批流弹窗
    onClose() {
      this.isApprovalPopup = false
    },
    onCloseApproval() {
      this.onClose()
        this.approvalForm = {
            isAgree: 1,
            auditContent: ''
        }
    },
    // 审批
    async onApproval() {
      await approval({
        serveCompanyId: this.approvalInfo.serveCompanyId,
        id: Number(this.approvalId),
        flow: this.approvalInfo.flow,
        params: {
          isAgree: this.approvalForm.isAgree,
          approverId: this.userId,
          auditContent: this.approvalForm.auditContent || (Number(this.approvalForm.isAgree) === 1 ? '同意' : Number(this.approvalForm.isAgree) === 2 ? '驳回' : '')
        }
      })
    },
    // 取消申请
    onCancelApply() {
      confirm('', '确认取消流程吗').then(async () => {
        this.approvalForm = {
          isAgree: 0,
          auditContent: ''
        }
        await this.onApproval()
        this.$message.success('取消流程成功')
        this.$emit('doSearch')
        this.isApprovalPopup = false
      })
    },
    async onApprovalReminders() {

    },
    async onDefineApproval() {
      if (!this.approvalForm.isAgree) {
        this.$message.error('请选择审批操作')
        return
      }
      await this.onApproval()
      this.$emit('doSearch')
      this.isApprovalPopup = false
      if (Number(this.approvalForm.isAgree) === 1) {
        this.$message.success('审批成功')
      } else {
        this.$message.success('驳回成功')
      }
    }
  }
})
